var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_14391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 2V4.66667C10 4.84348 10.0702 5.01305 10.1953 5.13807C10.3203 5.2631 10.4899 5.33333 10.6667 5.33333H13.3333",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11.3333H7.33333C6.97971 11.3333 6.64057 11.1929 6.39052 10.9428C6.14048 10.6928 6 10.3536 6 10V3.33333C6 2.97971 6.14048 2.64057 6.39052 2.39052C6.64057 2.14048 6.97971 2 7.33333 2H10L13.3333 5.33333V10C13.3333 10.3536 13.1929 10.6928 12.9428 10.9428C12.6928 11.1929 12.3536 11.3333 12 11.3333Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 11.3346V12.668C10.6667 13.0216 10.5262 13.3607 10.2762 13.6108C10.0261 13.8608 9.68697 14.0013 9.33334 14.0013H4.66668C4.31305 14.0013 3.97392 13.8608 3.72387 13.6108C3.47382 13.3607 3.33334 13.0216 3.33334 12.668V6.0013C3.33334 5.64768 3.47382 5.30854 3.72387 5.05849C3.97392 4.80844 4.31305 4.66797 4.66668 4.66797H6.00001",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_14391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon05);
export default __webpack_public_path__ + "static/media/dashboard-icon-05.c1a8b85bc4bff6af26cf2d36051ef5b7.svg";
export { ForwardRef as ReactComponent };